import { useEffect, useState } from "react";
import { FileSignature, ChevronDown, ChevronUp } from "lucide-react";
import { api } from "@/lib/api";
import { AgreementTermsForm } from "@/components/admin/AgreementTermsForm";
import { AgreementInviteForm } from "@/components/admin/AgreementInviteForm";
import { AgreementsList } from "@/components/admin/AgreementsList";

/** Admin → Settings: business terms + e-sign invites for partner technicians. */
export function AdminAgreements() {
  const [items, setItems] = useState(null);
  const [showTerms, setShowTerms] = useState(false);
  const load = () => api.get("/admin/agreements").then((r) => setItems(r.data)).catch(() => setItems([]));
  useEffect(() => { load(); }, []);
  if (items === null) return null;
  const signed = items.filter((a) => a.status === "signed").length;

  return (
    <div className="dg-card rounded-xl p-5" data-testid="admin-agreements-card">
      <div className="flex items-center gap-2">
        <FileSignature className="w-4 h-4 text-[#FFD600]" />
        <div className="dg-eyebrow">Partner agreements · e-sign</div>
        <span className="dg-chip ml-auto text-slate-300" data-testid="agreements-count-chip">{signed} signed · {items.length - signed} other</span>
      </div>
      <p className="text-sm text-slate-400 mt-2">Send a new technician a private link. They read the agreement, fill in their business details, tick the consents and type their name. Both of you get a PDF with a signature certificate; signed copies stay here.</p>

      <button type="button" onClick={() => setShowTerms(!showTerms)} className="mt-4 w-full flex items-center justify-between rounded-lg border border-slate-700 px-3 py-2 text-sm text-slate-200 hover:border-cyan-400" data-testid="terms-toggle">
        <span>1 · Business terms (fill the blanks once)</span>{showTerms ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}
      </button>
      {showTerms && <div className="mt-3 rounded-lg border border-slate-800 p-3"><AgreementTermsForm /></div>}

      <div className="mt-5">
        <div className="text-sm text-slate-200 mb-2">2 · Invite a technician</div>
        <AgreementInviteForm onCreated={load} />
      </div>

      <div className="mt-6">
        <div className="text-sm text-slate-200 mb-1">3 · Sent & signed</div>
        <AgreementsList items={items} onChanged={load} />
      </div>
    </div>
  );
}
